
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.61 15.78"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M6.81 15.78a.5.5 0 0 1-.31-.1 14 14 0 0 1-3.85-3.92A15.81 15.81 0 0 1 .74 7.6 16.35 16.35 0 0 1 0 2.94a.55.55 0 0 1 .35-.5L6.61 0A.53.53 0 0 1 7 0l6.26 2.4a.55.55 0 0 1 .35.5 16.35 16.35 0 0 1-.74 4.66 15.81 15.81 0 0 1-1.87 4.2 14 14 0 0 1-3.85 3.92.49.49 0 0 1-.34.1zM1.1 3.33a16.9 16.9 0 0 0 .69 4 14.84 14.84 0 0 0 1.79 3.86 12.68 12.68 0 0 0 3.23 3.38A12.8 12.8 0 0 0 10 11.18a14.84 14.84 0 0 0 1.79-3.86 16.9 16.9 0 0 0 .69-4l-5.7-2.2z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M8.13 7.75a1.33 1.33 0 0 0-.78-1.21V3H6.26v3.5a1.33 1.33 0 0 0 0 2.5v1.65h1.09V9a1.33 1.33 0 0 0 .78-1.25z"}})])])])
          )
        }
      }
    